import { useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import { Trigger } from 'models/automation/Triggers';
import useTriggerAddEditModal from './modal/useTriggerAddEditModal';
import { TRIGGER_ADD_EDIT_MODAL_ID } from './modal/TriggerAddEditModal.constants';

const TriggersTabModal = () => {
  const { key } = useParams();
  const location = useLocation();
  const hasInit = useRef(false);
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const {
    openAddTriggerModal,
    openDuplicateTriggerModal,
    openEditTriggerModal,
  } = useTriggerAddEditModal();

  useEffect(() => {
    if (key && !activeModals[TRIGGER_ADD_EDIT_MODAL_ID] && !hasInit.current) {
      if (key === 'add') {
        openAddTriggerModal();
      } else if (key === 'duplicate') {
        const trigger = (location.state as { trigger?: Trigger })?.trigger;
        if (trigger) {
          openDuplicateTriggerModal(trigger);
        }
      } else {
        openEditTriggerModal({ triggerUid: key });
      }
      hasInit.current = true;
    }
  }, [key, activeModals]);

  useEffect(() => {
    return () => {
      if (hasInit.current) {
        closeModal(TRIGGER_ADD_EDIT_MODAL_ID);
        hasInit.current = false;
      }
    };
  }, []);

  return null;
};

export default TriggersTabModal;
